import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';

type WrapperProps = {
  lighterBorder?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  border: 1px solid ${props => (props.lighterBorder ? '#F4F7F9' : '#cfd8dc')};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  width: 100%;
`;

export const Title = styled(Typ20)`
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const Text = styled.text`
  text-anchor: middle;
  font-size: 12px;
`;

export const Line = styled.line`
  stroke: #eceff1;
`;
